import { ApplicationsParams } from "./types";

export const applicationsKeys = {
  list: (params?: ApplicationsParams) =>
    params ? ["applications", params] : ["applications"],
  getOne: (applicationId: string) => ["applications", applicationId],
  getConnect: (applicationId: string) => [
    "applications",
    applicationId,
    "connect",
  ],
};
